module.exports = __webpack_public_path__ + "img/search.d770daf9.svg";